import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from 'components/scroll-to-top';

import Description from './description';

import '../style.css';



class EmissionsPage extends React.PureComponent {
  render() {

    return (
      <div className="l-product-page">
        <ScrollToTop />

        <header className="demo-header -fixed">
          <h1>
            Emissions Inventory from satellites
          </h1>
          <div className="demo-button">
            <Link className="c-button products-page-btn -large" to='/products/emissions/demo'>See demo</Link>
          </div>
        </header>
        <header className="products-header">
          <div className="header-title">
            <h1>
              Emissions Inventory from satellites
                </h1>
            <div className="demo-button">
              <Link className="c-button products-page-btn -large" to='/products/emissions/demo'>See demo</Link>
            </div>
          </div>
          <div className="header-intro">
            <p>Monthly-updated worldwide emissions at 1-Km resolution.</p>
          </div>
        </header>
        <div>
          <div className="container">
            <div className="row">
              <div className="col-sm">
                <Description />
              </div>
            </div>
          </div>
        </div >
      </div >
    );
  }
}

export default EmissionsPage;



// WEBPACK FOOTER //
// ./src/pages/products/emissions/index.js